import getFeatures from "utils/getFeatures";

import { Feature } from "types/Features";

const getFeature = (name: string): Feature | undefined => {
  const featuresByOpco: Feature[] | undefined = getFeatures();

  return featuresByOpco?.find((feature: Feature) => feature.name === name);
};

export default getFeature;

export const isFeatureActive = (name: string) => !!getFeature(name)?.active;

export const isFeatureActiveByPartner = (name: string, partner: string) => {
  return (
    isFeatureActive(name) &&
    (getFeature(name)?.options?.partners?.includes(partner) || getFeature(name)?.options?.forAllPartners)
  );
};
